import { ProductsFilter, useProductsList } from "modules/products";
import { useTranslation } from "react-i18next";
import { Modal, Pagination, SearchInput } from "ui";

import { ProductsSelectorTable } from "./atoms";
import { ProductsSelectorProps } from "./ProductsSelector.types";

import styles from "./ProductsSelector.module.scss";

const ProductsSelector = ({
  isOpen,
  onClose,
  value,
  maxValueLength,
  excludeVariantIds,
  filterFn,
  title,
  onChange
}: ProductsSelectorProps) => {
  const { t } = useTranslation();

  const {
    products,
    totalItems,
    searchValue,
    page,
    isLoading,
    setPage,
    setSearchValue,
    categories,
    filterMeta,
    isCategoriesLoading,
    isFilterMetaLoading
  } = useProductsList({
    excludeVariantIds
  });

  const filteredProducts = filterFn
    ? (products ?? []).filter(filterFn)
    : (products ?? []);

  return (
    <Modal
      title={title ?? t("Select Products")}
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.selectProductModalContent}
      footer={<></>}
    >
      <div className={styles.container}>
        <ProductsFilter
          categories={categories}
          filterMeta={filterMeta}
          isCategoriesLoading={isCategoriesLoading}
          isFilterMetaLoading={isFilterMetaLoading}
        />

        <div className={styles.products}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={`${t("Search")}...`}
          />

          <div className={styles.products_tableContainer}>
            <ProductsSelectorTable
              products={filteredProducts}
              isLoading={isLoading}
              value={value}
              onChange={onChange}
              maxValueLength={maxValueLength}
            />
          </div>

          <Pagination
            currentPage={page}
            onChange={setPage}
            totalItems={totalItems}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ProductsSelector;
